import { Link, useLocation } from "react-router-dom";
import { useSeo } from "@/hooks/useSeo";

export default function NotFound() {
  const location = useLocation();

  useSeo({
    title: "页面未找到 — 天海翼影视内容站",
    description: "抱歉，你访问的页面不存在或已被移除，可以返回首页继续浏览天海翼的影视作品与资讯。",
  });

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background-50 px-4 text-center">
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-100">
        <i className="ri-film-line text-3xl text-primary-700" />
      </div>
      <p className="mt-6 font-heading text-6xl font-bold text-primary-700">404</p>
      <h1 className="mt-3 font-heading text-xl font-semibold text-foreground-950 md:text-2xl">
        抱歉，这个页面没有找到
      </h1>
      <p className="mt-2 max-w-md text-sm leading-relaxed text-foreground-600">
        你访问的页面可能已被移除或链接有误。你可以回到首页，继续浏览天海翼的影视作品与最新资讯。
      </p>
      <p className="mt-2 font-mono text-xs text-foreground-400">{location.pathname}</p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          返回首页
        </Link>
        <Link
          to="/works"
          className="cursor-pointer whitespace-nowrap rounded-md border border-background-300 px-6 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
        >
          浏览影视作品
        </Link>
      </div>
    </div>
  );
}